<mdw-fade [isVisible]="animationState() === 'animated'" [verticalOffset]="8">
  <div [style.width.px]="376" class="vflex-000 flex-align-items-center">
    <div
      class="vpad-050 hpad-150 blur-background border-radius-400 vflex-200 flex-align-items-center"
    >
      @let count = alertCount();

      <p class="dense medium">{{ count }} more</p>
    </div>
  </div>
</mdw-fade>
